export default __webpack_public_path__ + "static/media/panel.bf32ab60.svg";